import React, { Component } from 'react';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class Test071225 extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterThursday2'>
      <img className='logo' src={logo}></img>
      <br />
      <h3>Examination 07/12/2025 Candidates</h3>
      <br />
      <br />


        <div><Link to='/conduct-metapornc'>1. AAT 7833  MS.METAPORN CHIM-IM(2KYU)---Trying for 1KYU</Link></div>
        <br />
        <div><Link to='/conduct-kanokphonc'>2. AAT 7779  MS.KANOKPHON CHAIYAWONG(2KYU)---Trying for 1KYU</Link></div>
        <br />
        <div><Link to='/conduct-supachais'>3. AAT 7832  CPO1.SUPACHAI SITTIRUK(2KYU)---Trying for 1KYU</Link></div>
        <br />
        <div><Link to='/conduct-rattapongp'>4. AAT 4478  LT.RATTAPONG PONGSUWAN(3KYU)---Trying for 2KYU</Link></div>
        <br />
        <div><Link to='/conduct-ratchadapornn'>5. AAT 7822  MS.RATCHADAPORN NONNUSAT(5KYU)---Trying for 4KYU</Link></div>
        <br />
        <div><Link to='/conduct-thomasm'>6. AAT 7923  MR.THOMAS MOENKEMEIER(6KYU)---Trying for 5KYU</Link></div>
        <br />
        <div><Link to='/conduct-napolp'>7. ATT  7910  MR.NAPOL PITAYAPAT(6KYU)---Trying for 5KYU</Link></div>
        <br />
        <div><Link to='/conduct-asdawutc'>8. ATT  7925  LT.ASDAWUT CHODSAPTHAWEE(7KYU)---Trying for 6KYU</Link></div>
        <br />
        <div><Link to='/conduct-nirunc'>9. AAT 7783  LT.NIRUN CHANTAWARO(8KYU)---Trying for 7KYU</Link></div>
        <br />
        <div><Link to='/conduct-sunyal'>10. AAT 7972  CPO1.SUNYA LAEID(8KYU)---Trying for 7KYU</Link></div>
        <br />
        <div><Link to='/conduct-angieo'>11. ATT 7884  MS.ANGELICA JOSELINE OLSSON(8KYU)--Trying for 7KYU</Link></div>
        <br />
        <div><Link to='/conduct-pakawadn'>12. AAT  8008  MR.PAKAWAD NANTAJURAPLO(9KYU)---Trying for 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-marceld'>13. AAT 8024  MR.MARCEL DEKE(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-andrewl'>14. AAT 7973  MR.ANDREW LINDQVIST(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-barbarab'>15. AAT 8027  MS.BARBARA BARZARKINA(10KYU)---Accquired Rank 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-nannaphatp'>16. AAT 8028  ​MS.NANNAPHAT PRIYACHANASAKUL(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-kanyaphatp'>17. AAT 8026  MS.KANYAPHAT PRIYACHANASAKUL(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-naruekarink'>18. AAT 8036  MR.NARUEKARIN KHEMARUT(WB)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-carinad'>19. AAT 8037  MS.CARINA DEKE(WB)---Trying for 10KYU</Link></div>
        <br />

        <div>
          Thailand's Aikido Association Registration...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default Test071225;
